
import React , { useState, useRef, useEffect } from "react"
import { BNPrintLabel } from '../../../../src/networking/NetworkingOrders'

export function PrintLabel({bnOrderNo}) {
    const [body, setBody] = useState('');
    const [features, setFeatures] = useState('');

  useEffect(() => {
    const loadDefault = async () => {
      const json_request = {
        BNOrderNo: bnOrderNo
      }
      const response = await BNPrintLabel(json_request);
      if (response !== undefined) {
        setBody(response.body);
        setFeatures(response.features);
      }
    }
    loadDefault();
  }, []);
  
  const handlePrint = () => {
    const printWindow = window.open("", "", features)
    if (printWindow) {
      printWindow.document.write(body)
      printWindow.document.close()
      printWindow.print()
    }
  }

  return (
    <button className="uk-button uk-button-green" onClick={handlePrint} >
        Print Label
    </button>
  )
}

export async function Print(bnOrderNo, listSelectedOrders) {
  let cadena="";
  if(listSelectedOrders != undefined && listSelectedOrders != null){
    cadena = listSelectedOrders.join(","); 
  }  
  const json_request = {
    BNOrderNo: bnOrderNo,
    ListSelectedOrders: cadena
  }
  const response = await BNPrintLabel(json_request);
  const printWindow = window.open("", "_blank", response.features)
  if (printWindow) {
    printWindow.document.write(response.body)
    printWindow.document.close()
    printWindow.print()
  }
}